import { useDataGridSettings } from "@/components/DataGridSettingsProvider";
import ColorInterval from "@/models/ColorInterval";

export function useGetColorByValue() {
  const { colorIntervals } = useDataGridSettings();

  return (field: string, value: number) => {
    const intervals: ColorInterval[] = colorIntervals[field] || [];
    const match = intervals.find(
      ({ min, max }) => (min === undefined || value >= min) && (max === undefined || value <= max),
    );
    return {
      color: match ? match.color : "#000000",
      bgColor: match ? match.backgroundColor : undefined,
    };
  };
}
